(ns opengb.i18n.locale
  (:require [clojure.spec.alpha :as s]
            [clojure.string :as string]))

(def default-locale
  "Provides a default locale for situations where user locale isn't available,
  or when the locale needs to be consistent across users."
  :en-CA)

(s/def :opengb.i18n/locale
  (s/or :keyword keyword?
        :string  string?))

(defn canonicalize-locale
  "Accepts a string or keyword that might be a valid locale.
  If it is a valid locale, then provides it in keyword form.
  Else, provides `nil`."
  [maybe-locale]
  (let [conformed (s/conform :opengb.i18n/locale maybe-locale)]
    (cond (= ::s/invalid conformed)      nil
          (= :keyword (first conformed)) (second conformed)
          (= :string (first conformed))  (keyword (second conformed))
          :else                          nil)))

(defn- locale->language
  "Extract the language part of a locale keyword."
  [locale]
  (-> locale
      name
      (string/split #"-")
      first
      keyword))

(defn- locales->language-locale-map
  "Transform a list of locales into a map of language to locale."
  [locales]
  (into {} (map (juxt locale->language identity) locales)))

(defn select-locale
  "Given a vector of available locales and a vector of user-preferred locales,
  select the most appropriate locale."
  [available preferred]
  (let [available-locales   (set (conj available default-locale))
        available-languages (locales->language-locale-map available-locales)
        preferred-locales   (->> (conj (vec preferred) default-locale)
                                 (map canonicalize-locale)
                                 (remove nil?))]
    (some (fn [locale]
            (or (available-locales locale)
                (available-languages (locale->language locale))))
          preferred-locales)))
